import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LevelGuard } from './core/guards/level.guard';
import { LoginComponent } from './login/login.component';
import { LayoutComponent } from './layout/layout.component';
const routes: Routes = [
  {path:'login',component: LoginComponent},
  {path:'',  component:LayoutComponent, canActivate: [AuthGuard, LevelGuard],  loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule)},
  // { path: '', component: LayoutComponent },
  // {path:'', component:LayoutComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' },)],
  exports: [RouterModule],
  providers: [AuthGuard, LevelGuard]
})
export class AppRoutingModule { }
